import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getSubsidiariesHeadingDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  subsidiariesPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
};
